import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { GET_SOURCES_GLOBAIS_INIT, UPDATE_SOURCE_GLOBAL_ATIVO_INIT } from '../actionTypes';
import { FarmaError } from 'src/integracoes/modelos/erros';
import { getSourcesGlobaisSuccess, atualizaSourceGlobalAtivoSuccess, errorSourcesGlobaisMsg } from './actions';
import { obtemSourcesGlobais, atualizarSourceGlobalAtivo } from 'src/integracoes/servicos/mongo-atlas/funcoes/sourcesGlobais';

// --------------------------- Obter Sources Globais ---------------------------------------------------------
const fetchObtemSourcesGlobais = async () => {
  try {
    const { status, dados, mensagem } = await obtemSourcesGlobais();
    if (status && dados) {
      return { isError: false, globalAtivo: dados, errorMessage: null };
    }
    return { isError: true, globalAtivo: null, errorMessage: mensagem };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseObtemSourcesGlobais() {
  try {
    const { isError, globalAtivo, errorMessage } = yield call(fetchObtemSourcesGlobais);
    if (!isError) {
      yield put(getSourcesGlobaisSuccess({ globalAtivo }));
    } else {
      yield put(errorSourcesGlobaisMsg({ msg: errorMessage || 'Erro ao carregar sources globais' }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(errorSourcesGlobaisMsg({ msg: mensagem }));
  }
}

function* watchObtemSourcesGlobais() {
  yield takeEvery(GET_SOURCES_GLOBAIS_INIT as any, parseObtemSourcesGlobais);
}

// --------------------------- Atualiza Source Global Ativo ---------------------------------------------------------
const fetchAtualizarSourceGlobalAtivo = async (payload: { source: 'pgfarma' | 'iqvia' | 'closeup'; ativo: boolean }) => {
  try {
    const { status, mensagem } = await atualizarSourceGlobalAtivo(payload);
    if (status) {
      return { isError: false, msg: mensagem };
    }
    return { isError: true, msg: mensagem };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseAtualizaSourceGlobalAtivo({ payload }: any) {
  try {
    const { isError, msg } = yield call(fetchAtualizarSourceGlobalAtivo, payload);
    if (!isError) {
      yield put(atualizaSourceGlobalAtivoSuccess({ msg }));
    } else {
      yield put(errorSourcesGlobaisMsg({ msg: msg || 'Erro ao atualizar source global' }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(errorSourcesGlobaisMsg({ msg: mensagem }));
  }
}

function* watchAtualizaSourceGlobalAtivo() {
  yield takeEvery(UPDATE_SOURCE_GLOBAL_ATIVO_INIT as any, parseAtualizaSourceGlobalAtivo);
}

// WATCHS ------------------------------------------------
export default function* sourcesGlobaisSaga() {
  yield all([
    fork(watchObtemSourcesGlobais),
    fork(watchAtualizaSourceGlobalAtivo)
  ]);
}
